export default IconMeterCube => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-meter-cube" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M17 5h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5" />
  <path d="M4 12v6" />
  <path d="M4 14a2 2 0 0 1 2 -2h.5a2.5 2.5 0 0 1 2.5 2.5v3.5" />
  <path d="M9 15.5v-1a2.5 2.5 0 1 1 5 0v3.5" />
</svg>`;